import React from 'react'
import { BlockError, OrderBuildRequest } from 'Pages/orders_design'
import {
	UnBlockRequestModal,
	BlockRequestModal,
} from 'Pages/orders_design/components/desktop_orders/modals'
import { ReassignMobileModal } from 'Pages/orders_design/components/mobile_orders/Modals'
import { isEmpty } from 'lodash'
import { ShortDataModel } from 'Models'

export const getMinCompanyExistErrorText = (error: any): string => {
	const productsErrors = error[BlockError.min_company_existence_check_failed]
	if (isEmpty(productsErrors)) return ''
	const productNames = ShortDataModel.concatNames(
		Array.isArray(productsErrors) ? productsErrors : [productsErrors]
	)
	return [productsErrors].length === 1
		? `Подача заявки невозможна. Срок ведения бизнеса не соответствует требованиям к продукту ${productNames}`
		: `Подача заявки невозможна. Срок ведения бизнеса не соответствует требованиям к продуктам:  ${productNames}`
}
const getTitleCode = (key: BlockError): string => {
	switch (key) {
		case BlockError.blocked_by_me:
			return 'orders.block_order'
		case BlockError.blocked_by_commerce:
		case BlockError.blocked_by_other:
			return 'orders.reassignment'
		case BlockError.unblock_request:
		case BlockError.call_easy_permission:
			return 'orders.unblock_order'
		case BlockError.rbidos_customer:
		case BlockError.min_company_existence_check_failed:
			return 'orders.create_order'
		case BlockError.unblock_request_file:
			return 'orders.unblock_request_file'
		case BlockError.blocked_by_priority_channel:
			return `orders.create_prohibition`
		default:
			return 'orders.unblock_order'
	}
}

const getHeaderIcon = (key: BlockError): string => {
	switch (key) {
		case BlockError.blocked_by_me:
		case BlockError.rbidos_customer:
		case BlockError.min_company_existence_check_failed:
		case BlockError.unblock_request_file:
		case BlockError.blocked_by_priority_channel:
			return 'lock'
		case BlockError.blocked_by_commerce:
		case BlockError.blocked_by_other:
			return 'swap'
		case BlockError.unblock_request:
		case BlockError.call_easy_permission:
			return 'unlock'
		default:
			return 'lock'
	}
}

const getText = (key: BlockError, error): string => {
	switch (key) {
		case BlockError.blocked_by_me:
			return (
				`У Вас есть действующая заявка на этого клиента. ` +
				`Новую заявку можно будет отправить после ${error[BlockError.blocked_by_me]}`
			)
		case BlockError.blocked_by_priority_channel:
			return `Вы не можете подать заявку на перезакрепление.`
		case BlockError.blocked_by_commerce:
		case BlockError.blocked_by_other:
			return 'Можно подать заявку на перезакрепление, вложив согласие на обработку персональных данных.'
		case BlockError.unblock_request:
			return 'Уже существует запрос на разблокировку по этому клиенту'
		case BlockError.call_easy_permission:
			return 'Без действующего разрешения колизея'
		case BlockError.rbidos_customer:
			return 'Отказ по иным причинам'
		case BlockError.min_company_existence_check_failed:
			return getMinCompanyExistErrorText(error)
		case BlockError.unblock_request_file:
			return 'Отсутствует файл "Согласие на передачу персональных данных"'
		default:
			return 'Отказ по иным причинам'
	}
}

export const createModalContent = (
	error,
	orderPayload: OrderBuildRequest,
	isMobile: boolean
): { Component } => {
	const keys = Object.keys(error)
	const key = keys[0]
	const headerIcon: string = getHeaderIcon(key as BlockError)
	const titleCode: string = getTitleCode(key as BlockError)
	let Component = null
	switch (key) {
		case BlockError.blocked_by_me:
		case BlockError.unblock_request:
		case BlockError.call_easy_permission:
		case BlockError.rbidos_customer:
		case BlockError.min_company_existence_check_failed:
		case BlockError.blocked_by_priority_channel:
			Component = (props) => (
				<BlockRequestModal
					isMobile={isMobile}
					title={titleCode}
					{...props}
					icon={headerIcon}
					text={getText(key, error)}
					error={key}
				/>
			)
			break
		case BlockError.unblock_request_file:
			Component = (props) => (
				<BlockRequestModal
					isMobile={isMobile}
					title={titleCode}
					{...props}
					icon={headerIcon}
					text={getText(key, error)}
				/>
			)
			break
		case BlockError.blocked_by_commerce:
		case BlockError.blocked_by_other:
			if (!isMobile) {
				Component = (props) => (
					<UnBlockRequestModal
						{...props}
						title={titleCode}
						icon={headerIcon}
						text={getText(key, error)}
						orderPayload={orderPayload}
					/>
				)
			} else {
				Component = (props) => (
					<ReassignMobileModal
						{...props}
						orderPayload={orderPayload}
						title={titleCode}
						text={getText(key, error)}
					/>
				)
			}
			break

		default:
			Component = null
	}
	return { Component }
}
